import {css} from '../../theme/css'

export const classes = {
  fill: css`
    position: absolute;
    inset-block-start: 0;
    inset-block-end: 0;
    inset-inline-start: 0;
    inset-inline-end: 0;
    opacity: 0;
    inline-size: 100%;
  `,
  rangeSegmentContainer: css`
    position: relative;
    inline-size: 166px;
  `,
  relative: css`
    position: relative;
  `,
  trail: css`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    inset-block-start: 0;
    inset-block-end: 0;
    inset-inline-end: 0;
  `,
  hidden: css`
    visibility: hidden;
  `,
}
